export const articles = [
  {
    id: 'a1',
    title: '古装大剧《长安夜行》开机三天紧急换角，剧组深夜发声明',
    slug: 'changan-yexing-change-role',
    category: '影视爆料',
    categorySlug: 'yingshi',
    excerpt:
      '开拍仅三天，原定男主突然退出，剧组当晚临时调整拍摄计划。工作人员透露，新演员已在次日凌晨进组试妆，档期压缩带来的连锁反应正在持续发酵。',
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20ancient%20chinese%20film%20set%20with%20warm%20lantern%20light%2C%20stylized%20editorial%20poster%20art%2C%20deep%20green%20and%20crimson%20tones%2C%20moody%20atmosphere%2C%20no%20text&width=800&height=450&seq=bg-art-yingshi-01&orientation=landscape',
    author: '爆瓜社编辑部',
    publishedAt: '2026-09-10 09:12',
    readTime: '4 分钟',
    heat: 98,
    comments: 1284,
    tags: ['影视爆料', '剧组换角', '古装剧'],
    blocks: [
      {
        type: 'p',
        text: '据多位剧组工作人员透露，古装剧《长安夜行》在开拍第三天临时更换男主角。原定演员因档期冲突退出，制片方连夜与替代人选沟通，新演员于次日凌晨完成定妆。',
      },
      { type: 'h2', text: '换角为何如此突然' },
      {
        type: 'p',
        text: '有工作人员表示，项目前期筹备周期被大幅压缩，主演的进组时间与另一部作品的补拍档期发生重叠。双方团队在开拍前已多次协调，但最终未能达成一致。',
      },
      {
        type: 'quote',
        text: '“景都搭好了，机器也架上了，人却换了，整个拍摄表要重排一遍。”——剧组灯光组工作人员',
      },
      {
        type: 'p',
        text: '截至发稿，制片方发布简短声明，称换角系“正常的创作调整”，已妥善处理相关合约事宜，后续拍摄将按新计划推进。该剧预计仍将在原定档期内完成主体拍摄。',
      },
    ],
    timeline: [
      { time: '09-08 21:40', text: '原定男主团队提出档期冲突，双方进入协商。' },
      { time: '09-09 02:10', text: '剧组暂停次日通告，重新排布拍摄计划表。' },
      { time: '09-10 01:30', text: '替代演员完成试妆，剧组发布正式换角公告。' },
    ],
  },
  {
    id: 'a2',
    title: '《我们的舞台》第三季录制现场：导师临时改赛制引选手落泪',
    slug: 'our-stage-season3-rule-change',
    category: '综艺现场',
    categorySlug: 'zongyi',
    excerpt:
      '原定的团队赛在录制中途被临时改为个人对决，多位选手当场情绪波动。现场观众回忆，改规则的消息直到开录前一小时才通知到人。',
    cover:
      'https://readdy.ai/api/search-image?query=stylized%20studio%20stage%20with%20colorful%20spotlights%20and%20empty%20chairs%2C%20editorial%20poster%20illustration%2C%20warm%20amber%20and%20green%20accents%2C%20no%20text&width=800&height=450&seq=bg-art-zongyi-01&orientation=landscape',
    author: '现场观察员',
    publishedAt: '2026-09-10 08:05',
    readTime: '3 分钟',
    heat: 91,
    comments: 876,
    tags: ['综艺现场', '赛制调整', '录制路透'],
    blocks: [
      {
        type: 'p',
        text: '《我们的舞台》第三季近日录制最新一期。多位现场观众向本刊表示，节目组在开录前一小时临时通知将团队赛改为个人对决，选手的排练内容需要当场调整。',
      },
      { type: 'h2', text: '现场情绪一度紧张' },
      {
        type: 'p',
        text: '由于个人对决意味着每位选手都要独立承担成败，几位原本依赖团队配合的选手在候场区明显紧张。有选手在听完规则后短暂离场调整状态，现场导演组随后安排心理疏导。',
      },
      {
        type: 'quote',
        text: '“规则改了之后，大家前面的排练基本作废，只能硬着头皮上。”——现场观众林同学',
      },
      {
        type: 'p',
        text: '节目组方面回应称，赛制优化是为了让舞台呈现更集中，并强调调整经过了与选手的沟通。该期节目预计在两周后播出。',
      },
    ],
    timeline: [
      { time: '09-09 13:00', text: '导演组召开临时会议，确定赛制调整方案。' },
      { time: '09-09 17:20', text: '选手收到规则变更通知，重新分配排练时间。' },
      { time: '09-09 21:00', text: '本期录制结束，现场安排补拍选手采访。' },
    ],
  },
  {
    id: 'a3',
    title: '巡演中途突然取消两站，歌手工作室回应：因声带需要休养',
    slug: 'tour-cancel-vocal-rest',
    category: '音乐动态',
    categorySlug: 'yinyue',
    excerpt:
      '原定于本周开唱的两站巡演在开演前四小时宣布取消。工作室发布说明称，歌手近期连续高强度演出，声带出现疲劳状况，医生建议停唱观察。',
    cover:
      'https://readdy.ai/api/search-image?query=empty%20concert%20stage%20with%20microphone%20stand%20and%20soft%20spotlight%20haze%2C%20stylized%20editorial%20poster%2C%20deep%20green%20and%20gold%20tones%2C%20no%20text&width=800&height=450&seq=bg-art-yinyue-01&orientation=landscape',
    author: '音乐快讯组',
    publishedAt: '2026-09-09 22:40',
    readTime: '3 分钟',
    heat: 84,
    comments: 612,
    tags: ['音乐动态', '巡演取消', '声带休养'],
    blocks: [
      {
        type: 'p',
        text: '歌手本轮巡演在开演前四小时宣布取消两站演出。工作室发布说明称，歌手连续多场高强度演出后声带出现明显疲劳，医生建议至少停唱一周进行观察。',
      },
      { type: 'h2', text: '退票与补偿方案' },
      {
        type: 'p',
        text: '主办方表示，已购票观众可选择全额退票或保留票根至改期场次使用，两项方案将在官方票务平台同步开放。对于已抵达演出城市的观众，主办方另提供周边权益补偿。',
      },
      {
        type: 'quote',
        text: '“不是不想唱，是医生说再唱可能伤到根本。”——巡演团队工作人员',
      },
      {
        type: 'p',
        text: '不少粉丝在社交平台表示理解，并主动提醒其他人不要聚集等候。改期场次的具体时间将在歌手身体状况评估后公布。',
      },
    ],
    timeline: [
      { time: '09-09 15:00', text: '团队收到医生建议，开始评估后续场次。' },
      { time: '09-09 17:30', text: '主办方与票务平台沟通退改方案。' },
      { time: '09-09 18:10', text: '官方发布取消公告与补偿说明。' },
    ],
  },
  {
    id: 'a4',
    title: '双顶流被拍同框出行，双方团队均未回应',
    slug: 'two-stars-photographed',
    category: '明星日常',
    categorySlug: 'mingxing',
    excerpt:
      '有网友在机场拍到两位高人气演员前后脚现身同一航班。照片流出后迅速登上讨论榜，但截至发稿，双方团队均未对传闻作出任何回应。',
    cover:
      'https://readdy.ai/api/search-image?query=stylized%20airport%20corridor%20with%20soft%20bokeh%20lights%20and%20blurred%20figures%2C%20editorial%20magazine%20illustration%2C%20muted%20green%20and%20cream%20tones%2C%20no%20text&width=800&height=450&seq=bg-art-mingxing-01&orientation=landscape',
    author: '路人视角',
    publishedAt: '2026-09-09 19:22',
    readTime: '2 分钟',
    heat: 95,
    comments: 1533,
    tags: ['明星日常', '路透', '机场同框'],
    blocks: [
      {
        type: 'p',
        text: '有网友在机场拍到两位高人气演员在同一天现身同一航班，照片在社交平台传播后迅速引发讨论。由于两人近期有合作项目在筹备，也有声音认为这只是一次正常工作行程。',
      },
      { type: 'h2', text: '团队保持沉默' },
      {
        type: 'p',
        text: '截至发稿，双方团队均未对相关传闻作出回应。有业内人士提醒，仅凭机场同框难以判断具体行程，呼吁外界不要过度解读。',
      },
      {
        type: 'quote',
        text: '“同行一趟就被说成什么，我们自己看了都想笑。”——不愿具名的经纪人',
      },
    ],
    timeline: [
      { time: '09-09 11:05', text: '网友在机场拍到两人先后现身。' },
      { time: '09-09 14:40', text: '相关照片被大量转发，登上讨论榜。' },
      { time: '09-09 19:00', text: '双方团队仍未就传闻作出回应。' },
    ],
  },
  {
    id: 'a5',
    title: '悬疑网剧《雾港》大结局提前泄露，平台连夜排查',
    slug: 'fog-harbor-ending-leak',
    category: '影视爆料',
    categorySlug: 'yingshi',
    excerpt:
      '距离会员大结局上线还有三天，《雾港》的关键剧情片段已在多个渠道流传。平台方连夜启动排查，并呼吁用户不要传播未上线内容。',
    cover:
      'https://readdy.ai/api/search-image?query=moody%20harbor%20fog%20scene%20at%20dusk%20with%20silhouetted%20cranes%2C%20stylized%20suspense%20poster%20art%2C%20teal%20green%20and%20charcoal%20tones%2C%20no%20text&width=800&height=450&seq=bg-art-yingshi-02&orientation=landscape',
    author: '爆瓜社编辑部',
    publishedAt: '2026-09-09 16:08',
    readTime: '3 分钟',
    heat: 88,
    comments: 734,
    tags: ['影视爆料', '剧集泄露', '悬疑剧'],
    blocks: [
      {
        type: 'p',
        text: '悬疑网剧《雾港》原定于本周日晚上线会员大结局。然而三天前，包含关键反转情节的片段开始在多个渠道流传，引发剧迷讨论。',
      },
      { type: 'h2', text: '平台启动紧急排查' },
      {
        type: 'p',
        text: '平台方回应称，已第一时间启动内容安全排查，并对相关传播链接进行处置。平台同时提醒用户，传播未上线剧集内容可能涉及侵权。',
      },
      { type: 'h2', text: '剧迷态度分化' },
      {
        type: 'p',
        text: '部分剧迷表示希望保持悬念，主动避开了相关话题；也有观众认为提前泄露反而打乱了追剧节奏。剧组尚未就此事发布进一步说明。',
      },
    ],
    timeline: [
      { time: '09-06 23:10', text: '关键反转片段首次在社交平台出现。' },
      { time: '09-07 09:30', text: '平台启动内容排查并处置传播链接。' },
      { time: '09-09 15:00', text: '平台发布声明，呼吁用户不传播未上线内容。' },
    ],
  },
  {
    id: 'a6',
    title: '红毯造型引热议，造型师深夜发文解释设计理念',
    slug: 'red-carpet-styling-explained',
    category: '品牌时尚',
    categorySlug: 'shishang',
    excerpt:
      '一袭不对称礼服在红毯后引发两极化评价。造型团队深夜发布长文，解释服装结构、面料来源与整体概念，回应外界对"用力过猛"的质疑。',
    cover:
      'https://readdy.ai/api/search-image?query=elegant%20fashion%20red%20carpet%20scene%20with%20abstract%20fabric%20draping%2C%20stylized%20editorial%20illustration%2C%20emerald%20green%20and%20gold%20accents%2C%20no%20text&width=800&height=450&seq=bg-art-shishang-01&orientation=landscape',
    author: '时尚观察',
    publishedAt: '2026-09-09 12:45',
    readTime: '4 分钟',
    heat: 79,
    comments: 528,
    tags: ['品牌时尚', '红毯造型', '造型团队'],
    blocks: [
      {
        type: 'p',
        text: '某颁奖礼红毯上，一袭不对称结构礼服成为当晚讨论度最高的造型之一。评价呈现明显两极化，有人认为前卫，也有人觉得不够协调。',
      },
      { type: 'h2', text: '造型团队的回应' },
      {
        type: 'p',
        text: '造型团队当晚发布长文，说明礼服采用手工定型面料，结构灵感来自建筑曲面，并解释了不对称设计是为了呼应舞台灯光下的动态效果。',
      },
      {
        type: 'quote',
        text: '“我们想做的不是安全牌，而是让造型在镜头里有记忆点。”——造型团队说明节选',
      },
      {
        type: 'p',
        text: '文章发布后，讨论风向有所缓和，不少网友开始从设计角度重新审视这套造型。相关话题在次日凌晨逐渐降温。',
      },
    ],
    timeline: [
      { time: '09-08 20:15', text: '红毯造型曝光，相关话题快速升温。' },
      { time: '09-08 23:50', text: '造型团队发布长文解释设计理念。' },
      { time: '09-09 08:30', text: '讨论风向转向设计解读，热度回落。' },
    ],
  },
  {
    id: 'a7',
    title: '直播间突发状况，人气主播当场宣布停播整改',
    slug: 'live-streamer-pause',
    category: '网红直播',
    categorySlug: 'wanghong',
    excerpt:
      '一场晚间直播在进行到一半时突然中断，主播随后在账号发布短文，宣布暂停直播进行团队整改。粉丝在评论区刷屏支持，也有用户提出不同看法。',
    cover:
      'https://readdy.ai/api/search-image?query=modern%20streaming%20studio%20with%20ring%20light%20and%20monitor%20glow%2C%20stylized%20editorial%20illustration%2C%20green%20and%20coral%20tones%2C%20no%20text&width=800&height=450&seq=bg-art-wanghong-01&orientation=landscape',
    author: '直播观察站',
    publishedAt: '2026-09-08 23:30',
    readTime: '2 分钟',
    heat: 76,
    comments: 401,
    tags: ['网红直播', '停播整改', '直播间'],
    blocks: [
      {
        type: 'p',
        text: '一场晚间直播在开播约两小时后突然中断，主播随后在账号发布短文，表示团队近期在高强度排播下出现状态波动，将暂停直播进行内部整改。',
      },
      { type: 'h2', text: '粉丝与路人反应不一' },
      {
        type: 'p',
        text: '评论区中，粉丝大多表示理解并等待回归；也有用户认为停播前的部分内容需要更规范。平台方面暂未就此事单独回应。',
      },
      {
        type: 'quote',
        text: '“先把内容做好再回来，比硬撑着播下去更重要。”——主播停播说明节选',
      },
    ],
    timeline: [
      { time: '09-08 20:00', text: '晚间直播正常开播。' },
      { time: '09-08 22:05', text: '直播突然中断，画面停留数分钟。' },
      { time: '09-08 23:10', text: '主播发布停播整改说明。' },
    ],
  },
  {
    id: 'a8',
    title: '老牌综艺宣布改版，常驻嘉宾阵容大换血',
    slug: 'classic-variety-reboot',
    category: '综艺现场',
    categorySlug: 'zongyi',
    excerpt:
      '播出至第八季的综艺宣布全面改版，多位常驻嘉宾不再参与新一季录制。节目组表示，改版将调整叙事节奏，加入更多户外实景拍摄。',
    cover:
      'https://readdy.ai/api/search-image?query=bright%20outdoor%20variety%20show%20set%20with%20colorful%20props%20and%20empty%20stools%2C%20stylized%20editorial%20illustration%2C%20amber%20and%20green%20palette%2C%20no%20text&width=800&height=450&seq=bg-art-zongyi-02&orientation=landscape',
    author: '综艺观察员',
    publishedAt: '2026-09-08 18:12',
    readTime: '3 分钟',
    heat: 71,
    comments: 356,
    tags: ['综艺现场', '节目改版', '嘉宾阵容'],
    blocks: [
      {
        type: 'p',
        text: '播出至第八季的老牌综艺宣布全面改版。节目组透露，新一季将减少棚内录制比例，增加户外实景任务，整体叙事节奏也会更紧凑。',
      },
      { type: 'h2', text: '阵容调整背后的考量' },
      {
        type: 'p',
        text: '随着多位常驻嘉宾不再参与新一季录制，节目组表示这是基于创作方向与个人档期的综合考虑，新一季会引入更多面孔。',
      },
      {
        type: 'quote',
        text: '“改版不是为了推翻过去，是想让节目重新有新鲜感。”——节目组负责人',
      },
      {
        type: 'p',
        text: '新一季预计在年底与观众见面，首期录制地点已确定在一座沿海城市。',
      },
    ],
    timeline: [
      { time: '09-05 10:00', text: '节目组内部确定改版方向。' },
      { time: '09-07 15:30', text: '常驻嘉宾阵容调整消息流出。' },
      { time: '09-08 17:00', text: '节目组发布正式改版说明。' },
    ],
  },
  {
    id: 'a9',
    title: '音乐节压轴换人，主办方称因天气原因调整顺序',
    slug: 'festival-lineup-swap',
    category: '音乐动态',
    categorySlug: 'yinyue',
    excerpt:
      '原定压轴的乐队临时改为提前登场，压轴位置由另一组艺人接替。主办方解释称，傍晚强对流天气导致彩排时间被大幅压缩。',
    cover:
      'https://readdy.ai/api/search-image?query=outdoor%20music%20festival%20stage%20at%20sunset%20with%20crowd%20silhouettes%2C%20stylized%20editorial%20poster%2C%20warm%20gold%20and%20deep%20green%20tones%2C%20no%20text&width=800&height=450&seq=bg-art-yinyue-02&orientation=landscape',
    author: '音乐快讯组',
    publishedAt: '2026-09-08 14:20',
    readTime: '2 分钟',
    heat: 68,
    comments: 289,
    tags: ['音乐动态', '音乐节', '演出调整'],
    blocks: [
      {
        type: 'p',
        text: '一场户外音乐节的演出顺序临时调整，原定压轴的乐队改为提前登场，压轴位置由另一组艺人接替，现场不少观众当场调整了观演计划。',
      },
      { type: 'h2', text: '天气是主要原因' },
      {
        type: 'p',
        text: '主办方解释称，傍晚出现的强对流天气导致舞台设备彩排时间被压缩，为保证安全与演出质量，只能调整出场顺序。',
      },
      {
        type: 'quote',
        text: '“安全第一，顺序可以之后再补一场。”——主办方现场说明',
      },
    ],
    timeline: [
      { time: '09-08 16:10', text: '气象预警发布，彩排短暂中断。' },
      { time: '09-08 17:40', text: '主办方确认演出顺序调整方案。' },
      { time: '09-08 19:00', text: '调整后的演出顺利进行。' },
    ],
  },
  {
    id: 'a10',
    title: '电影《归途列车》补拍传闻四起，导演回应只是正常补镜',
    slug: 'return-train-reshoot',
    category: '影视爆料',
    categorySlug: 'yingshi',
    excerpt:
      '有消息称电影《归途列车》在杀青半年后重新召集主创补拍。导演在采访中回应，补镜是后期制作阶段的常规流程，并不涉及剧情大改。',
    cover:
      'https://readdy.ai/api/search-image?query=night%20train%20interior%20with%20warm%20window%20light%20and%20empty%20seats%2C%20stylized%20cinematic%20poster%20art%2C%20amber%20and%20dark%20green%20tones%2C%20no%20text&width=800&height=450&seq=bg-art-yingshi-03&orientation=landscape',
    author: '爆瓜社编辑部',
    publishedAt: '2026-09-08 10:05',
    readTime: '3 分钟',
    heat: 64,
    comments: 231,
    tags: ['影视爆料', '电影补拍', '导演回应'],
    blocks: [
      {
        type: 'p',
        text: '有消息称，电影《归途列车》在杀青半年后重新召集部分主创进行补拍。消息传出后，关于“剧情大改”的猜测开始扩散。',
      },
      { type: 'h2', text: '导演的公开回应' },
      {
        type: 'p',
        text: '导演在采访中回应，补镜属于后期制作阶段的常规工作，主要涉及几处细节镜头的衔接与光线统一，并不涉及主线剧情的调整。',
      },
      {
        type: 'quote',
        text: '“每一部电影到最后都会有补镜，这真的不是新鲜事。”——导演采访节选',
      },
      {
        type: 'p',
        text: '影片的后期团队表示，目前的补拍不会影响原定的上映节奏。',
      },
    ],
    timeline: [
      { time: '09-06 09:00', text: '补拍消息在影视圈内传出。' },
      { time: '09-07 16:30', text: '“剧情大改”的猜测开始扩散。' },
      { time: '09-08 09:40', text: '导演在采访中回应补镜性质。' },
    ],
  },
  {
    id: 'a11',
    title: '演员被曝低调做公益多年，网友翻出早年旧照',
    slug: 'actor-quiet-charity',
    category: '明星日常',
    categorySlug: 'mingxing',
    excerpt:
      '一张多年前的活动合影被网友翻出，照片中的演员被指长期参与一项助学项目。相关话题在讨论区持续升温，但当事人仍未公开谈及此事。',
    cover:
      'https://readdy.ai/api/search-image?query=quiet%20sunlit%20classroom%20with%20empty%20desks%20and%20soft%20dust%20light%2C%20stylized%20editorial%20illustration%2C%20cream%20and%20sage%20green%20tones%2C%20no%20text&width=800&height=450&seq=bg-art-mingxing-02&orientation=landscape',
    author: '路人视角',
    publishedAt: '2026-09-07 20:40',
    readTime: '2 分钟',
    heat: 72,
    comments: 468,
    tags: ['明星日常', '公益', '旧照'],
    blocks: [
      {
        type: 'p',
        text: '一张多年前的活动合影近日被网友翻出，照片中的演员被指长期参与一项乡村助学项目，相关话题在讨论区持续升温。',
      },
      { type: 'h2', text: '当事人依旧沉默' },
      {
        type: 'p',
        text: '据项目志愿者透露，该演员多年来一直以个人名义提供支持，但从未主动对外宣传。截至发稿，当事人及团队仍未就此事公开发声。',
      },
      {
        type: 'quote',
        text: '“她只是让我们别声张，说做这些不是为了被看见。”——项目志愿者回忆',
      },
    ],
    timeline: [
      { time: '09-06 21:00', text: '早年合影被网友翻出并转发。' },
      { time: '09-07 12:20', text: '志愿者接受采访时提及长期支持。' },
      { time: '09-07 20:00', text: '话题热度上升，当事人仍未回应。' },
    ],
  },
  {
    id: 'a12',
    title: '新剧演员代言品牌同日官宣，被指档期撞车',
    slug: 'endorsement-same-day',
    category: '品牌时尚',
    categorySlug: 'shishang',
    excerpt:
      '同一部剧的两位演员在同一天官宣了不同品牌的代言。品牌方均表示发布时间为既定计划，但网友仍从物料细节中读出了"较劲"的意味。',
    cover:
      'https://readdy.ai/api/search-image?query=minimal%20product%20display%20podiums%20with%20soft%20studio%20lighting%20and%20green%20backdrop%2C%20stylized%20editorial%20illustration%2C%20clean%20harmonious%20composition%2C%20no%20text&width=800&height=450&seq=bg-art-shishang-02&orientation=landscape',
    author: '时尚观察',
    publishedAt: '2026-09-07 15:15',
    readTime: '2 分钟',
    heat: 61,
    comments: 197,
    tags: ['品牌时尚', '代言官宣', '新剧演员'],
    blocks: [
      {
        type: 'p',
        text: '同一部剧的两位演员在同一天先后官宣了不同品牌的代言。两家品牌方均表示发布时间为既定计划，与外界猜测无关。',
      },
      { type: 'h2', text: '物料细节被放大解读' },
      {
        type: 'p',
        text: '有网友从海报构图、配色和发布时间间隔中读出“较劲”意味。营销从业者则提醒，代言档期通常提前数月排定，同天发布更多是巧合。',
      },
      {
        type: 'quote',
        text: '“品牌排期看的是节点，不是谁和谁的关系。”——品牌营销从业者',
      },
    ],
    timeline: [
      { time: '09-07 10:00', text: '首位演员品牌代言物料发布。' },
      { time: '09-07 12:30', text: '第二位演员代言紧接官宣。' },
      { time: '09-07 14:50', text: '双方品牌均回应称属既定计划。' },
    ],
  },
];